import React from 'react';
import { Loader2 } from 'lucide-react';
import { useEffectiveSerial } from '@/hooks/useEffectiveSerial';
import NoDeviceError from '@/pages/NoDeviceError';

interface DeviceSerialGateProps {
  children: React.ReactNode;
}

/**
 * Gate component that ensures a valid device serial exists before allowing access.
 * Shows loading state while resolving, and NoDeviceError if no serial found.
 */
export const DeviceSerialGate: React.FC<DeviceSerialGateProps> = ({ children }) => {
  const { serial, isLoading } = useEffectiveSerial();

  // Show loading while resolving serial
  if (isLoading) {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center bg-gradient-to-b from-background to-muted/30">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  // No valid serial found - block access
  if (!serial) {
    return <NoDeviceError />;
  }

  // Valid serial - allow access
  return <>{children}</>;
};
